export default {
  error: {
    time: 'The video recording time is too short, please record again.',
    save: 'Save Failed',
    delete: 'This asset has been deleted, please select again.',
  },
  success: {
    msg: 'Recording saved successfully',
    export: 'Export task submitted',
    delet: 'Delete Successfully',
    save: 'Saved Successfully',
    copy: 'Copy Successfully',
  },
  empty: {
    title: 'There is no version under this project',
    desc: 'Create a version and start recording',
    add: 'Create Version',
  },
  navbar: {
    backList: 'Return to the screen recording project list',
    record: 'Screen Recorder',
    save: 'Save',
    export: 'Export',
    exportList: 'Export List',
  },
  left: {
    title: 'Product & Projects',
    projectInfo: {
      drop: 'Project',
      add: 'Create Version',
    },
    version: {
      title: 'Versions',
      copy: 'Copy',
      delete: 'Delete',
      copyDrop: {
        title: 'Copy Version',
        text: 'Version Name',
      },
      delDrop: {
        title: 'Tip',
        text: 'Are you sure to delete {versionname} version',
      },
    },
  },
  work: {
    top: {
      again: 'again',
      start: 'start',
      record: 'Start recording',
      finish: 'finished recording',
      play: 'record playback',
      palying: 'Playing Back',
      palyed: 'playback ended',
      againLoad: 'Reload',
    },
  },
  right: {
    recordParameter: 'Recording Parameters',
    videoSet: 'video design',
    videoSetting: {
      cursor: 'Record Cursor',
      time: 'Display timing',
      clickDisplay: 'Display when clicked',
      allDisplay: 'Always On Display',
      cursorSize: 'Cursor size',
      rotation: 'Rotation',
      image: 'Images',
    },
  },
  exportList: {
    title: 'Version export history',
  },
  imageUpload: {
    uploadRuleTips: {
      format: 'Images Format',
      fileSize: 'Image file size',
    },
  },
  PromptMessage: {
    assetNotFound: {
      title: 'Asset not found',
      label: 'The added assets were deleted.',
      continueLabel:
        'The added assets were deleted, still export will miss content. Still want to export this project?',
    },
    pleaseEnter: 'Please enter',
  },
  rule: {
    createSuccess: 'Created Successfully',
    nameLength: 'Name length is less than 20 characters',
    size: 'Please select a size',
    resolution: 'Please select a resolution',
  },
}
